import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  LayoutViewModel,
  LayoutZoneViewModel,
} from "../view-models/layout.view-model";
import { RectangleFViewModel } from "../../common/rectangle-f/rectangle-f.view-model";
import { RectangleF } from "../../../domain/rectangle-f";
import { ICommonUtilInterface } from "../../../domain/common/common-util.interface";
import { ELayoutZoneType } from "../../../domain/layouts/layoutZone";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ILayoutsRepository } from "../../../domain/layouts/layouts.repository";
import { ToastrService } from "ngx-toastr";
import { SearchService } from "../../../services/search.service";
import libraryStore from "../../../services/stores/library.store";
import { UserService } from "../../../domain/user-service";
import { ChannelRepository } from "../../../domain/channel-repository";
import { MediaRepository } from "../../../domain/media-repository";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: "evrideo-layout-editor",
  templateUrl: "./layout-editor.component.html",
  styleUrls: ["./layout-editor.component.scss"],
})
export class LayoutEditorComponent implements OnInit {
  vm: LayoutViewModel;
  @ViewChild("nameInput", { static: false }) nameInput: ElementRef;
  private _libraryStore = libraryStore;

  @HostListener("window:resize", ["$event"])
  onResize(event: UIEvent) {
    this.vm.onWindowResize(event);
  }

  constructor(
    private _commonUtils: ICommonUtilInterface,
    private _route: ActivatedRoute,
    private _layoutRepository: ILayoutsRepository,
    private _layoutsRepository: ILayoutsRepository,
    private _toastr: ToastrService,
    private _router: Router,
    private _searchService: SearchService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
    private _mediaRepository: MediaRepository,
    private _ngxSmartModalService: NgxSmartModalService,
  ) {}

  ngOnInit(): void {
    /*if (this._libraryStore.getLibraryType() !== 'layouts') {
      this._searchService.searchMode = 'layouts';
      this._libraryStore.setLibraryType('layouts');
      this._searchService.subjectModeNext();
    }*/

    this._route.params.subscribe(async (params: Params) => {
      const currentChannel = await this._userService.getCurrentChannel();
      const channelInfo = await this._channelRepository.getChannelInfoById(
        currentChannel.id,
      );
      const aspectRatio = channelInfo.aspectRationNumber;
      if (!!params["id"]) {
        const layoutId = params["id"];
        const existingLayout = (
          await this._layoutRepository.getLayouts(null, layoutId)
        )[0];
        if (existingLayout) {
          const zones = existingLayout.zones.map(
            (l) =>
              new LayoutZoneViewModel(
                l.index,
                l.volume,
                l.zLayer,
                new RectangleFViewModel(
                  l.position.x * 100,
                  l.position.y * 100,
                  l.position.height * 100,
                  l.position.width * 100,
                  false,
                ),
                l.zoneType,
                l.mediaId,
                l.mediaName,
                l.mediaThumbnailUrl,
                l.cropSettings,
                l.offsetFromBaseZoneMs,
                l.somMs,
                l.durationMs,
              ),
          );
          this.vm = new LayoutViewModel(
            existingLayout.id,
            existingLayout.name,
            zones,
            aspectRatio,
            this._commonUtils,
            this._layoutsRepository,
            this._toastr,
            this._channelRepository,
            this._mediaRepository,
            this._ngxSmartModalService,
            this._changeDetectorRef,
          );
        } else {
          this._router.navigate(["/layouts/new"]).then();
        }
      } else {
        this.vm = LayoutViewModel.createNewLayout(
          aspectRatio,
          this._commonUtils,
          this._layoutsRepository,
          this._toastr,
          this._channelRepository,
          this._mediaRepository,
          this._ngxSmartModalService,
          this._changeDetectorRef,
        );
      }
      this.vm.onInit();

      this._changeDetectorRef.markForCheck();
      this._changeDetectorRef.detectChanges();

      // Set initial content for the contenteditable element
      setTimeout(() => {
        this.setInitialContent();
      }, 0);
    });
  }

  onNameInput(event: Event): void {
    const target = event.target as HTMLElement;
    // Update the view model without triggering change detection that affects the element
    this.vm.name = target.textContent || "";
  }

  onNameBlur(event: Event): void {
    const target = event.target as HTMLElement;
    // Ensure the name is properly set when the element loses focus
    this.vm.name = target.textContent || "";
  }

  onNameFocus(event: Event): void {
    // Set initial content when the element gains focus
    const target = event.target as HTMLElement;
    if (!target.textContent && this.vm.name) {
      target.textContent = this.vm.name;
    }
  }

  private setInitialContent(): void {
    if (this.nameInput && this.nameInput.nativeElement && this.vm.name) {
      this.nameInput.nativeElement.textContent = this.vm.name;
    }
  }
}
